import { useMemo } from "react";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import InternalAccountViewAll from "../../../../containers/Accounts/InternalAccount/InternalAccountViewAll";
import { useNavigate } from "react-router-dom";

const InternalAccountPopUp = ({
  // identity / context
  id,
  type,
  flow,
  accountType,
  subType,

  onClosepop,
  onClose,

  sourceDestiAcc,
  ispanbankRequired,
  associateAccount,
  associatepanNumber,
  associateIFSC,
  associateaccountNumber,
  activeType,
  setActiveType,
  remPan,
  setRemPan,
  remAccount,
  setRemAccount,
  remIFSC,
  setRemIFSC,
  typePanBank,

  onAccountSelect,

  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,

  beneAccountId,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
  setOpenInternalAssociate,
  setOpenBeneAssociate,

  scheduleIntenralTxn,
  LabelAccounts,
  onCardNavigate,

  handleButtonClick: handleButtonClickProp,
}) => {
  const navigate = useNavigate();

  const handleClosePopup = () => {
    if (onClose) {
      onClose();
    } else if (onClosepop) {
      onClosepop();
    }
    setRemAccount?.("");
    setRemIFSC?.("");
  };

  const handleButtonClick = (dataItem) => {
    if (handleButtonClickProp) {
      handleButtonClickProp(dataItem);
      return;
    }

    if (type === "viewAll") {
      onAccountSelect?.(
        dataItem.name.trim(),
        dataItem.bank_acc_no.trim(),
        dataItem.ifsc_code.trim(),
        dataItem.id,
      );
    } else {
      onAccountSelect?.(
        dataItem?.name.trim(),
        dataItem?.bank_acc_no.trim(),
        dataItem?.ifsc_code.trim(),
        dataItem?.bank_name,
        dataItem?.category,
        dataItem?.pan_no,
        dataItem?.id,
        dataItem?.labels,
        dataItem?.internal_account,
      );

      if (associateTxn === "associateTxn") {
        setOpenInternalAssociate?.(false);
      }
      if (BeneTxnAssocAcct) {
        setAssociateModalOpen?.(false);
      }
    }
  };

  const headerTitle = useMemo(() => {
    if (
      accountType === "internal" ||
      accountType === "beneficiary" ||
      BeneTxnAssocAcct ||
      associateTxn === "associateTxn"
    ) {
      return "Associated accounts";
    }

    if (flow === "internalTxn") {
      return "Select internal account";
    }

    return "Select beneficiary account";
  }, [accountType, BeneTxnAssocAcct, associateTxn, flow]);

  const headersubtext = useMemo(() => {
    if (
      accountType === "internal" ||
      BeneTxnAssocAcct ||
      associateTxn === "associateTxn"
    ) {
      return "The accounts listed below are linked to the selected internal account.";
    }

    if (accountType === "beneficiary") {
      return "The accounts listed below are linked to the selected beneficiary account.";
    }

    return "Only active (pending & approved) accounts can be selected. Source and destination account cannot be same.";
  }, [accountType]);

  return (
    <div>
      <LargePopupRedirect
        closeiconhandleFunction={handleClosePopup}
        isfullViewrequired={sourceDestiAcc ? true : false}
        ispanbankRequired={ispanbankRequired}
        togglepan={() => {
          setActiveType?.("pan");
          setRemPan?.(associatepanNumber);
          setRemAccount?.("");
          setRemIFSC?.("");
        }}
        toggleBank={() => {
          setActiveType?.("bank");
          setRemPan?.("");
          setRemAccount?.(associateaccountNumber);
          setRemIFSC?.(associateIFSC);
        }}
        fullviewbtnText="Open in full view"
        fullviewhandleFunction={() => {
          handleClosePopup();
          navigate("/internal_account_dashboard/internal_account_view_all");
        }}
        fullviewicon={ICONS?.REDIRECT}
        isbottomSectionneed={false}
        headerTitle={headerTitle}
        headersubtext={headersubtext}
      >
        <InternalAccountViewAll
          id={id}
          type={type}
          subType={subType}
          typepop={"popup"}
          typePanBank={typePanBank}
          onClosepop={onClose ?? onClosepop}
          handleButtonClick={handleButtonClick}
          associateAccount={associateAccount}
          associatepanNumber={associatepanNumber}
          associateIFSC={associateIFSC}
          associateaccountNumber={associateaccountNumber}
          setOpenInternalAssociate={setOpenInternalAssociate}
          setOpenBeneAssociate={setOpenBeneAssociate}
          beneAccountId={beneAccountId}
          BeneTxnAssocAcct={BeneTxnAssocAcct}
          accountType={accountType}
          flow={flow}
          setTxnPayLoad={setTxnPayLoad}
          txnPayLoad={txnPayLoad}
          setIsNeft={setIsNeft}
          setIsImps={setIsImps}
          setIsRtgs={setIsRtgs}
          setAssociateModalOpen={setAssociateModalOpen}
          associateTxn={associateTxn}
          scheduleIntenralTxn={scheduleIntenralTxn}
          LabelAccounts={LabelAccounts}
          remPan={remPan}
          remAccount={remAccount}
          remIFSC={remIFSC}
          activeType={activeType}
          onCardNavigate={onCardNavigate}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default InternalAccountPopUp;
